<template>
    <img class="border-radius-s" :src="paymentCardSource" style="width: 32px;"/>
</template>
<script>
    import PaymentCardBrands from '@/data/payment-card-brands';

    const mapCardBrandToSvg = {
        [PaymentCardBrands.visa]:
            '/static/icons/payment-instruments/visa/visa-card-dark.svg',
        [PaymentCardBrands.amex]:
            '/static/icons/payment-instruments/amex/amex-dark.svg',
        [PaymentCardBrands.mastercard]:
            '/static/icons/payment-instruments/mastercard/mastercard-dark.svg',
        [PaymentCardBrands.discovery]:
            '/static/icons/payment-instruments/discover/discover-card-dark.svg',
        [PaymentCardBrands.maestro]:
            '/static/icons/payment-instruments/maestro/maestro-card-dark.svg',
        [PaymentCardBrands.solo]:
            '/static/icons/payment-instruments/switch/switch-card-dark.svg',
        [PaymentCardBrands.electron]:
            '/static/icons/payment-instruments/visa/visa-card-dark.svg',
        [PaymentCardBrands.jcb]:
            '/static/icons/payment-instruments/jcb/jcb-card-dark.svg',
        [PaymentCardBrands.voyager]:
            '/static/icons/payment-instruments/visa/visa-card-dark.svg',
        [PaymentCardBrands.dinersClub]:
            '/static/icons/payment-instruments/diners-club/diners-club-dark.svg',
        [PaymentCardBrands.switch]:
            '/static/icons/payment-instruments/switch/switch-card-dark.svg',
        [PaymentCardBrands.laser]:
            '/static/icons/payment-instruments/laser/laser-card-dark.svg',
        [PaymentCardBrands.chinaUnionPay]:
            '/static/icons/payment-instruments/unionpay/unionpay-card-dark.svg',
        [PaymentCardBrands.astroPayCard]:
            '/static/icons/payment-instruments/visa/visa-card-dark.svg',
        [PaymentCardBrands.fuel]:
            '/static/icons/payment-instruments/visa/visa-card-dark.svg',
    };

    export default {
        name: 'v-payment-card',
        props: {
            type: {
                type: String,
                validator: type => Object.values(PaymentCardBrands).includes(type),
                default: PaymentCardBrands.visa,
            },
        },
        computed: {
            paymentCardSource() {
                return mapCardBrandToSvg[this.type];
            },
        },
    };
</script>
